common.View.create('website::layouts.Main', {

    onDOMLoad()
    {

    },
});
